import { Component, inject, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import * as FileSaver from 'file-saver';
import { AllegatiMovService } from 'src/app/shared/services/allegati-mov.service';
import { confirm } from 'devextreme/ui/dialog';
import { AllegatiMovimenti } from 'src/app/models/allegati-movimenti';
import notify from 'devextreme/ui/notify';
import {
  DxDataGridComponent,
  DxPopupComponent,
  DxTemplateDirective,
} from 'devextreme-angular';
import { DxiColumnComponent } from 'devextreme-angular/ui/nested';

@Component({
  selector: 'app-detail-allegati-mov',
  templateUrl: './detail-allegati-mov.component.html',
  styleUrls: ['./detail-allegati-mov.component.scss'],
  imports: [
    DxPopupComponent,
    DxDataGridComponent,
    DxTemplateDirective,
    DxiColumnComponent,
  ],
  standalone: true,
})
export class DetailAllegatiMovComponent implements OnInit {
  private allS = inject(AllegatiMovService);
  private sanitizer = inject(DomSanitizer);
  @Input() idMov: number;
  allegatiList: AllegatiMovimenti[];

  popupImageVisible = false;
  currentImage: SafeResourceUrl;

  loadPanelVisible = false;

  ngOnInit(): void {
    this.loadDataSource();
  }

  scaricaFileAllegato(allegato: AllegatiMovimenti) {
    this.allS.scarica(allegato.id).subscribe({
      next: (res) => {
        FileSaver.saveAs(res, allegato.nomeFile);
      },
      error: (error) => {
        this.loadPanelVisible = false;
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, 'warning');
        } else {
          notify('Errore scarica allegato', 'warning');
        }
      },
    });
  }

  loadDataSource() {
    if (this.idMov > 0) {
      this.allS.listByMovimento(this.idMov).subscribe({
        next: (res) => {
          this.allegatiList = res;
        },
        error: (error) => {
          this.loadPanelVisible = false;
          if (error?.status == 500 && error?.error?.title) {
            notify(error?.error?.title, 'warning');
          } else {
            notify(
              'Errore caricamento allegati movimento ' + this.idMov,
              'warning',
            );
          }
        },
      });
    }
  }

  eliminaFile(allegato: AllegatiMovimenti) {
    const result = confirm('<i>Vuoi eliminare l\'allegato?</i>', 'Conferma');
    result.then((dialogResult) => {
      if (dialogResult) {
        this.allS.delete(allegato.id).subscribe({
          next: () => {
            console.log('Allegato eliminato');
            this.loadDataSource();
          },
          error: (error) => {
            this.loadPanelVisible = false;
            if (error?.status == 500 && error?.error?.title) {
              notify(error?.error?.title, 'warning');
            } else {
              notify('Errore eliminazione allegato', 'warning');
            }
          },
        });
      }
    });
  }

  visualizzaFile(allegato: AllegatiMovimenti) {
    this.loadPanelVisible = true;
    this.allS.scarica(allegato.id).subscribe({
      next: (res) => {
        this.loadPanelVisible = false;
        const url = window.URL.createObjectURL(res);
        window.open(url);
      },
      error: (error) => {
        this.loadPanelVisible = false;
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, 'warning');
        } else {
          notify('Errore download file', 'warning');
        }
      },
    });
  }

  visualizzaImmagine(allegato: AllegatiMovimenti) {
    this.allS.getImmagine(allegato.id).subscribe((res) => {
      this.currentImage = this.sanitizer.bypassSecurityTrustResourceUrl(
        'data:image;base64,' + res,
      );
      this.popupImageVisible = true;
    });
  }

  endsWith(str, suffix) {
    if (str == undefined) {
      return false;
    }
    return (
      str
        .toUpperCase()
        .indexOf(suffix.toUpperCase(), str.length - suffix.length) !== -1
    );
  }
}
